import { forwardRef } from "react";
import { Notifications } from "../components/notifications";
import { ContextNotificationsProvider } from "../context/index";
import { NotificationsProps, NotificationsRef } from "../types/index";

const LayoutNotifications = forwardRef<
  NotificationsRef,
  Pick<NotificationsProps, "className">
>((props, ref) => {
  return (
    <ContextNotificationsProvider>
      <Notifications ref={ref} className={props.className} />
    </ContextNotificationsProvider>
  );
});

LayoutNotifications.displayName = "LayoutNotifications";

export default LayoutNotifications;
